import React from "react";
import CarportOrderForm from "../carport_order_form/CarportOrderForm";

const OrderForm = () => {
    return <CarportOrderForm />;
};

export default OrderForm;
